import sendToServer from './send-to-server';

const Topics = {
  init() {
    if (!($('.topics').length > 0)) return;
    $('.topic .remover').click(this.handleTopicRemoverClick.bind(this));
  },

  handleTopicRemoverClick(event) {
    const button = $(event.target).closest('.remover');
    sendToServer('/api/v2/topic_preferences/' + button.data('topic-id'),
                 null,
                 () => { location.reload() },
                 "DELETE");
  }
};

$(document).ready(()=> {
  Topics.init();
});
